import React from 'react';
import ReactTooltip from 'react-tooltip';

const RadioButton = ({
  field: { name, value, onChange, onBlur },
  form: { errors, touched },
  id,
  label,
  disabled,
  info,
  checked,
  onCustomChange = null,
  message,
  style = {},
  StyledLabel = null,
}) => {
  const renderChildren = () => {
    return (
      <>
        {label}
        <input
          name={name}
          id={id}
          type="radio"
          value={value}
          disabled={disabled}
          checked={checked}
          onChange={(e) => {
            if (onCustomChange) {
              onCustomChange(e);
            } else onChange(e);
          }}
          onBlur={onBlur}
        />
        <span className="radio-checkmark"></span>
        &nbsp;
        {info && (
          <span>
            <i
              className="fa fa-question-circle"
              data-tip
              data-for="permanent"
            />

            <ReactTooltip
              id="permanent"
              globalEventOff="click"
              delayHide={1000}
            >
              <p style={{ width: '150px' }}>{message}</p>
            </ReactTooltip>
          </span>
        )}
      </>
    );
  };

  return (
    <div className="form-group" style={{ ...style }}>
      {StyledLabel ? (
        <StyledLabel>{renderChildren()}</StyledLabel>
      ) : (
        <label className="custom-radio-container">{renderChildren()}</label>
      )}
    </div>
  );
};

export { RadioButton };
